export type MktVersionTypes = "v3" | "v4" | "v5" | "v6";
export function versionToPathPrefix(version: MktVersionTypes) {
  if (version === "v3") return "v3";
  if (version === "v4") return "promotion";
  if (version === "v5") return "v5";
  if (version === "v6") return "v6";
  return `${version}`;
}
